// extracted by mini-css-extract-plugin
export default {"active":"SuperAdminDashboardSideNavbar_active__aP+t9","inactive":"SuperAdminDashboardSideNavbar_inactive__e2PJm"};